const Copyright = () => {
  return (
    <p className="text-small text-darkGrey text-center whitespace-nowrap">
      © {new Date().getFullYear()}, Veegil Media LLC. All Rights Reserved.
    </p>
  );
};

export default Copyright;
